import { render, staticRenderFns } from "./IndexVuetify.vue?vue&type=template&id=52490bbc&"
import script from "./IndexVuetify.vue?vue&type=script&lang=js&"
export * from "./IndexVuetify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports